var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownExpand = function SvgDropdownExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.628 8.13a.433.433 0 0 1 .619 0L10 10.927l2.753-2.797a.433.433 0 0 1 .619 0 .45.45 0 0 1 0 .629l-3.063 3.11a.433.433 0 0 1-.618 0L6.628 8.76a.45.45 0 0 1 0-.629Z",
    fill: "#666"
  })));
};
export default SvgDropdownExpand;